// src/components/Home/FeaturedProducts.jsx
import React, { useState, useEffect } from "react";
import Heading from "../Products/Heading";
import Product from "../Products/Product";
import ProductLoader from "../../Loader/ProductLoader";
import ApiService from "../../../service/ApiService";
import { apiPaths } from "../../../service/apiPaths";


const FeaturedProducts = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

 useEffect(() => {
    const fetchFeaturedProducts = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await ApiService({
          method: "GET",
          endpoint: apiPaths.featuredProducts, // ONLY THIS LINE CHANGED
        });

        // Rest of your existing logic stays exactly the same
        if (response.success) {
          let newArrivals = [];
          if (Array.isArray(response.data)) {
            newArrivals = response.data;
          } else if (response.data?.products) {
            newArrivals = response.data.products;
          }


          console.log("Fetched featured products:", newArrivals);
          setProducts(newArrivals);
        } else {
          setError("Failed to fetch featured products");
        }
      } catch (err) {
        console.error("Error fetching featured products:", err);
        setError("Failed to fetch featured products");
      } finally {
        setLoading(false);
      }
    };

    fetchFeaturedProducts();
  }, []);

  return (
    <div className="w-full py-12 bg-white px-4">
      <div className="mx-auto px-4">
        <div className="flex justify-between items-center mb-8">
          <Heading
            heading="New Arrivals"
            className="text-3xl font-bold text-gray-800"
          />
        </div>

        {loading ? (
          <ProductLoader />
        ) : error ? (
          <div className="text-center py-12 bg-white rounded-lg shadow-md">
            <p className="text-xl text-red-500">{error}</p>
          </div>
        ) : products && products.length > 0 ? (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-4">
            {products.slice(0, 4).map((product, index) => (
              <div
                key={product._id || index}
                className="transform transition-all duration-300 hover:scale-105"
              >
                <Product product={product} variant="minimal" />
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-12 bg-white rounded-lg shadow-md">
            <p className="text-xl text-gray-500">
              No featured products available at the moment.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default FeaturedProducts;
